module.exports = __webpack_public_path__ + "img/RETASO_ROUND.36aad94f.png";